import React from 'react';
import { Badge } from '@chakra-ui/react';

interface StatusBadgeProps {
  variant: string;
  width?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  children,
  variant,
  width = '90px',
}) => {
  return (
    <Badge
      colorScheme={variant}
      px={2}
      py={1}
      borderRadius={4}
      w={width}
      textAlign="center"
      fontSize="11px"
    >
      {children}
    </Badge>
  );
};
